import { patch } from 'bootstrap/load-snabbdom';
import { IMsgConfig } from './models';
import { trackCtx } from './helpers';
import { default as SDXModalDialog, SDXModalDialogConfig } from 'lib/generic/SDXModalDialog';


function openModal(evt : JQuery.ClickEvent) {
	trackCtx(evt);

	const $target = $(evt.currentTarget);
	const config : SDXModalDialogConfig = {
		title: $target.data('modal-title'),
		url: $target.data('modal-url'),
	};
	if($target.data('modal-width')) {
		config.width = $target.data('modal-width');
	}
	if($target.data('modal-height')) {
		config.height = $target.data('modal-height');
	}

	SDXModalDialog.show(config);
}

function RenderMsgOption({
	config,
} : {
	config : IMsgConfig;
}) {
	return <div
		className="col-xs-12 col-md-6 tracking-info-holder margin-bottom-1"
		attrs-data-conversion-category={config.tracking['data-conversion-category']}
		attrs-data-conversion-detail={config.tracking['data-conversion-detail']}
		attrs-data-conversion-class={config.tracking['data-conversion-class']}
		attrs-data-track-action={config.tracking['data-track-action']}
		attrs-data-track-category={config.tracking['data-track-category']}
		attrs-data-track-label={config.tracking['data-track-label']}
		attrs-data-track-linkname={config.tracking['data-track-linkname']}
		attrs-data-track-location={config.tracking['data-track-location']}
		>
		{config.channel === 'sms' && <RenderSMS config={config} />}
		{config.channel === 'wa' && <RenderWa config={config} />}
		{config.channel === 'abc' && <RenderAbc config={config} />}
	</div>;
}

function RenderAbc({
	config,
} : {
	config : IMsgConfig;
}) {
	return <a
		attrs-href={config.abcUrl}
		className="abc-chat-link"
		on-click={trackCtx}
		attrs-target="_blank"
		attrs-data-role="none">
		<img className="wa-logo"
			attrs-src="/etc/designs/base/resources/images/apple_business_chat.png"
			attrs-width="50"
			attrs-height="50"
		/>
		{config.label}
	</a>;
}

function RenderWa({
	config,
} : {
	config : IMsgConfig;
}) {
		return <a
			attrs-href={config.waUrl}
			className="wa-chat-link"
			on-click={trackCtx}
			attrs-target="_blank"
			attrs-data-role="none">
			{config.type !== 'link' &&
				<img className="wa-logo"
					attrs-src="/etc/designs/base/resources/images/whatsapp.svg"
					attrs-width="50"
					attrs-height="50"
				/>
			}
			{config.label}
		</a>;
}

function RenderSMS({
	config,
} : {
	config : IMsgConfig;
}) {
		if(config.modalPath) {
			return <RenderSMSDesktop config={config}/>;
		}

		return <RenderSMSMobile config={config}/>;
}

function RenderSMSMobile({
	config,
} : {
	config : IMsgConfig;
}) {
		return <a
			className="sms-chat-link"
			attrs-href={config.smsUrl}
			on-click={trackCtx}
			attrs-data-role="none">
			{config.type !== 'link' &&
				<span className="sms-logo">
					<i className="icon icon--s3 icon-163-sms sc-white"></i>
				</span>
			}
			{config.label}
		</a>;
}

function RenderSMSDesktop({
	config,
} : {
	config : IMsgConfig;
}) {
	return <button
		type="button"
		className="link sms-chat-link"
		attrs-data-modal-url={config.modalPath}
		attrs-data-modal-title={config.modalTitle}
		attrs-data-modal-width={config.modalWidth}
		attrs-data-modal-height={config.modalHeight}
		on-click={openModal}>
		{config.type !== 'link' &&
			<span className="sms-logo">
				<i className="icon icon--s3 icon-163-sms sc-white"></i>
			</span>
		}
		{config.label}
	</button>;
}

function RenderMsgChannel({
	title,
	introductionText,
	additionalText,
	msg,
} : {
	title : string;
	introductionText : string;
	additionalText : string;
	msg : IMsgConfig[];
}) {
	return <div className="contact-holder">
		{title &&
			<h4 className="sc-navy margin-bottom-3">{title}</h4>
		}
		{introductionText &&
			<div className="introduction-text margin-bottom-2"
				innerHTML={introductionText}>
			</div>
		}
		<div className="row show-grid">
			{msg.map(cfg => {
				return <RenderMsgOption
				config={cfg}/>;
			})}
		</div>

		{additionalText &&
			<div className="additional-text margin-top-2"
				innerHTML={additionalText}
			></div>
		}
	</div>;
}

export function renderMsgChannel(
	target : HTMLElement,
	title : string,
	introductionText : string,
	additionalText : string,
	channels : IMsgConfig[],
) {
	return patch(
		target,
		<RenderMsgChannel
			title={title}
			introductionText={introductionText}
			additionalText={additionalText}
			msg={channels}
		/>,
	);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/MsgChannel.tsx